import { Icon, Typography } from 'components'
import { theme } from 'styles/theme/hav-theme'

import * as S from './styles'

type FileUploadToastProps = {
  progress: number
}

export const FileUploadToast: React.FC<FileUploadToastProps> = ({ progress }) => {
  return (
    <S.Wrapper>
      <S.Spinner>
        <Icon color={theme.colors.primary[20]} icon="loader" size={'25'} />
      </S.Spinner>
      <S.Content>
        <Typography design="hav-default-03-text">Carregando o seu arquivo...</Typography>
        <S.LoadingBar>
          <S.LoadingFill progress={progress} />
        </S.LoadingBar>
      </S.Content>
    </S.Wrapper>
  )
}
